import { Router } from 'react-router-dom';

import { store, persistor } from 'core/store';
import { utilities } from 'core/use-cases';

const { PersistGate, Provider: StoreProvider, history } = utilities;

export const ProviderStore = ({ children }: { children?: React.ReactNode }): JSX.Element => {
  return (
    <StoreProvider store={store}>
      <PersistGate persistor={persistor}>
        <Router history={history}>{children}</Router>
      </PersistGate>
    </StoreProvider>
  );
};
